import { render, staticRenderFns } from "./RmrTabs.vue?vue&type=template&id=458f859e&scoped=true&"
import script from "./RmrTabs.vue?vue&type=script&lang=js&"
export * from "./RmrTabs.vue?vue&type=script&lang=js&"
import style0 from "./RmrTabs.vue?vue&type=style&index=0&id=458f859e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f859e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
